module.exports = __webpack_public_path__ + "img/avatar_random_13.35f9eb2b.png";